import React from 'react';
import * as Linking from 'expo-linking';
import CardListTab from './CardListTab';
import SetList from './SetList';
import { NavigationContainer } from '@react-navigation/native';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { NavigationEvents } from "react-navigation";
import VolumeContext from './VolumeContext'
import DeviceInfo from 'react-native-device-info';
import DeviceContext from './DeviceContext'


const App = ({navigation}) => {
  const Tab = createBottomTabNavigator();
  const config = {
    screens: {
      Cards: 'cards/:cardSet?/:cardID?',
      Heroes: 'heroes/:cardID?',
      Sets: 'sets',
      Battlegrounds: 'battlegrounds/:cardID?',
      Duels: 'duels/:cardID?'
    }
  }
  const linking = {
    prefixes: ['https://hearthsfx.github.io'],
    config: config
  }

  const volumeHook = React.useState(100)
  const [deviceType, setDeviceType] = React.useState('')

  DeviceInfo.getUserAgent().then(userAgent => {
    setDeviceType(String(userAgent).toLowerCase().includes("mobi") ? 'mobile' : 'desktop')
  })

  return (
    <VolumeContext.Provider value={volumeHook}>
      <DeviceContext.Provider value={deviceType}>
        <NavigationContainer linking={linking}>
          <Tab.Navigator>
            <Tab.Screen name="Cards" component={CardListTab} initialParams = {{cardSet: 'all'}} />
            <Tab.Screen name="Heroes" component={CardListTab} initialParams = {{}} />
            <Tab.Screen name="Sets" component={SetList}/>
            {/* <Tab.Screen name="Battlegrounds" component={CardListTab} initialParams = {{}} /> */}
            
         </Tab.Navigator>
        </NavigationContainer>
      </DeviceContext.Provider>
    </VolumeContext.Provider>
  )
}

export default App
